<footer id="footer" class="footer">
  <div class="footer-cont">
    <div class="categories-cont">
      <h6>{{'FOOTER_MODULE.TITLES.CATEGORIES_TITLE' | transloco}}</h6>
      <ul class="footer-list">
        <ng-container *ngFor="let category of categories; trackBy: trackById">
          <li>
            <a target="_blank" [href]="category.link">{{category.title | transloco}}</a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="legal-links-cont">
      <h6>{{'FOOTER_MODULE.TITLES.INFORMATION_LINKS' | transloco}}</h6>
      <ul class="footer-list">
        <ng-container *ngFor="let link of footerLinks; trackBy: trackById">
          <li *ngIf="link.available">
            <a rel="nofollow" [href]="link.url" target="_blank">{{link.name | transloco}}</a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="legal-links-cont">
      <h6>{{'FOOTER_MODULE.TITLES.LEGAL_TERMS' | transloco}}</h6>
      <ul class="footer-list">
        <ng-container *ngFor="let link of legalLinks; trackBy: trackById">
          <li *ngIf="link.available">
            <ng-container *ngIf="!!link.state; else hrefTemplate">
              <a [routerLink]="[link.url]" [state]="link.state" skipLocationChange>
                {{ link.name | transloco }}
              </a>
            </ng-container>
            <ng-template #hrefTemplate>
              <a rel="nofollow" [href]="link.url" target="_blank">{{link.name | transloco}}</a>
            </ng-template>
          </li>
        </ng-container>
        <li *ngIf="isPE">
          <a [routerLink]="['responsable-tourism']" skipLocationChange>
            {{'FOOTER_MODULE.NOTICES.RESPONSABLE_TOURISM' | transloco}}
          </a>
        </li>
      </ul>
    </div>
    <div class="social-media-cont">
      <div class="download-app">
        <h6>{{'FOOTER_MODULE.TITLES.DOWNLOAD_APP' | transloco}}</h6>
        <div class="cont-apps">
          <a [href]="ios.link" target="_blank" rel="nofollow">
            <i aria-hidden="true" class="icon-apple"></i>
            <p>{{ios.name}}</p>
          </a>
          <a [href]="android.link" target="_blank" rel="nofollow">
            <i aria-hidden="true" class="icon-android"></i>
            <p>{{android.name}}</p>
          </a>
        </div>
      </div>
      <div class="follow-us">
        <h6>{{'FOOTER_MODULE.TITLES.FOLLOW_LINKS' | transloco}}</h6>
        <ul class="social-networks">
          <li><a [href]="facebookUrl" target="_blank" rel="nofollow" class="facebook"><i aria-hidden="true" class="icon-facebook"></i></a>
          </li>
          <li><a [href]="twitterUrl" target="_blank" rel="nofollow" class="twitter">
              <i aria-hidden="true" class="icon-twitter"></i></a></li>
          <li><a [href]="instagramUrl" target="_blank" rel="nofollow" class="instagram">
              <i aria-hidden="true" class="icon-instagram"></i></a></li>
        </ul>
      </div>
      <div class="contact operated-by">
        <p #openOperatorCert [innerHTML]="operatedBy$ | async"></p>
      </div>
      <ng-container *ngIf="isPE">
        <div class="complaints-book">
          <a [href]="urlComplaintsBook" target="_blank" rel="nofollow">
            <img loading="lazy" [src]="COMPLAINTS_BOOK | ImageCdn">
          </a>
        </div>
        <div class="complaints-book">
          <a [href]="urlFooterDocPDF" target="_blank" rel="nofollow">
            <img loading="lazy" [src]="MINCETUR | baseImage : MINCETUR_PATH ">
          </a>
        </div>
      </ng-container>
      <div class="btn-repentance" (click)="onBtnRepentance()" *ngIf="btnRepentance">
        <button>{{ 'HOME_MODULE.CANCEL_PURCHASE' | transloco }}</button>
      </div>
    </div>
  </div>
  <div class="creative-commons-cont">
    <p>{{'FOOTER_MODULE.CREATIVE_COMMONS' | transloco: { year: year } }}</p>
  </div>

  <ng-container *ngIf="showOperatiorCert">
    <app-modal [classType]="'home-mobile-image-operated-by'" [width]="860" (toggleModal)="toggleOperatiorCert()">
      <ng-container content>
        <div class="cont-image-operated-by">
          <img class="op-cert-img" [src]="footerOperatedByImages | baseImage: 'web/travel/footer/operator-legal'">
        </div>
      </ng-container>
    </app-modal>
  </ng-container>

</footer>


